export const obtener_formulario_omitiendo_imagenes_ya_guardadas = (registro, ...omitir_imagenes) => {
    let datosFormulario = new FormData();
    for (const llave in registro) {
        if (Object.hasOwnProperty.call(registro, llave)) {
            const valor = registro[llave];
            if (llave !== "accion") {
                if (valor instanceof File) {
                    datosFormulario.append(llave, valor, valor.name);
                } else if (![...omitir_imagenes].includes(llave)) {
                    datosFormulario.append(llave, valor);
                }
            }
        }
    }
    return datosFormulario;
}


export const obtener_formulario_completo = registro => {
    let datosFormulario = new FormData();
    for (const llave in registro) {
        if (Object.hasOwnProperty.call(registro, llave)) {
            const valor = registro[llave];
            if (llave !== "accion") {
                if (valor instanceof File) {
                    datosFormulario.append(llave, valor, valor.name);
                } else {
                    datosFormulario.append(llave, valor);
                }
            }
        }
    }
    return datosFormulario;
}